//import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ViewProfileLayer = () => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_BASE_URL}/backend/users/update-password`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: storedUser.email, 
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                }),
            });

            const data = await response.json();

            if (data.status) {
                toast.success(data.message || "Password updated successfully");
                // Clear form fields
                setOldPassword('');
                setNewPassword('');
                setErrorMessage('');
            } else {
                toast.error(data.message || "Failed to update password");
                setErrorMessage(data.message || "Failed to update password");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "An error occurred";
            toast.error(errorMessage);
            setErrorMessage(errorMessage);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="row gy-4">
            <div className="col-lg-12">
                <div className="card h-100">
                    <div className="card-body p-24">
                        <form onSubmit={handleSubmit}>
                            <ul className="nav border-gradient-tab nav-pills mb-20 d-inline-flex" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24 active"
                                        id="pills-change-passwork-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-change-passwork"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-change-passwork"
                                        aria-selected="false"
                                        tabIndex={-1}
                                    >
                                        Change Password
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-change-passwork" role="tabpanel" aria-labelledby="pills-change-passwork-tab" tabIndex="0">
                                    <div className="mb-20">
                                        <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Old Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="your-password"
                                                placeholder="Enter Old Password*"
                                                value={oldPassword}
                                                onChange={(e) => setOldPassword(e.target.value)}
                                            />
                                            <span
                                                className={`toggle-password ${passwordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={togglePasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>

                                    <div className="mb-20">
                                        <label htmlFor="new-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            New Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={confirmPasswordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="new-password"
                                                placeholder="Enter New Password*"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                            />
                                            <span
                                                className={`toggle-password ${confirmPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={toggleConfirmPasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                    <button type="submit" className="btn btn-success">Update Password</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ViewProfileLayer;